Namespace 'CustomerVisualMode'

class CustomerVisualMode.TeamWidgetDataTranslator
  constructor: (assignedTeams) ->
    @assignedTeams = assignedTeams

  name: (dataItem) ->
    teamId = dataItem.name
    @assignedTeams.get(teamId)?.get('name') || String(teamId)
